import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Footer from '../components/Footer'

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            univs:{},
            clubtypes:{},
            selected_univ: {},
            selected_clubtype: {}
        }
    }
    componentDidMount () {
        this.fetchUnivs();
        this.fetchClubtypes();
    }
    handleToClubPage = () => {
        if( !Object.keys(this.state.selected_univ).length ){
            alert('大学を選択してください。');
        } else if( !Object.keys(this.state.selected_clubtype).length ){
            alert('競技を選択してください。');
        } else {
            fetch(process.env.REACT_APP_API_URL + '/get-master-id/ct_id/'+this.state.selected_clubtype.id+'/univ_id/'+this.state.selected_univ.id+'/?key=' + process.env.REACT_APP_API_KEY).then((response) => response.json()).then((responseJson) => {
                if(responseJson.id){
                    this.props.history.push('/club/'+responseJson.id);
                } else {
                    alert('部活情報が見つかりませんでした。');
                }
            });
        }
    };
    fetchUnivs(ct_id){
        let api = process.env.REACT_APP_API_URL + '/get-univs';
        if(ct_id){
            api += '/ct_id/'+ct_id;
        }
        api += '?key='+process.env.REACT_APP_API_KEY;
        fetch(api).then((response) => response.json()).then((responseJson) => {
            console.log(responseJson.data);
            if( !responseJson.data ){
                this.setState({});
            } else {
                this.setState({univs: responseJson.data});
            }
        });
    }
    fetchClubtypes(univ_id){
        let api = process.env.REACT_APP_API_URL + '/get-clubtypes';
        if(univ_id){
            api += '/univ_id/'+univ_id;
        } else {
            return;
        }

        api += '?key='+process.env.REACT_APP_API_KEY;
        fetch(api).then((response) => response.json()).then((responseJson) => {
            console.log(responseJson.data);
            if( !responseJson.data ){
                this.setState({});
            } else {
                this.setState({clubtypes: responseJson.data});
            }
        });
    }
    clickUniv(univ){
        this.setState({selected_univ: univ});
        this.fetchClubtypes(univ.id);
    }
    renderUnivByKana(kana, univs_by_row){
        let list = [];
        for(let univ of univs_by_row) {
            list.push(<li key={univ.id}><a onClick={()=>this.clickUniv(univ)} data-toggle="collapse" data-target="#option-school">{univ.name}</a></li>);
        }
        return (
            <div key={kana} className="float-left item-seven-columnup columnup-1">
                <div className="title-item-seven-columnup">
                    <span>{kana}行</span>
                </div>
                <ul>
                    {list}
                </ul>
            </div>
        );
    }
    renderUnivs(){
        if( Object.keys(this.state.univs).length==0 ){
            return null;
        }
        let list_by_row = [];
        for(let kana in this.state.univs) {
            let ul = this.renderUnivByKana(kana, this.state.univs[kana]);
            list_by_row.push(ul);
        }
        return (
            <div className="seven-column-up clearfix">
                {list_by_row}
            </div>
        );
    }
    getUnivById(id){
        for(let kana in this.state.univs) {
            for(let v of this.state.univs[kana]) {
                if(v.id==id){
                    return v;
                }
            }
        }
        return {};
    }
    selectUniv(e){
        let univ = this.getUnivById(e.target.value);
        this.setState({selected_univ: univ});
        this.fetchClubtypes(univ.id);
    }
    renderUnivsSelect(){
        if( Object.keys(this.state.univs).length==0 ){
            return null;
        }
        let options = [];
        for(let kana in this.state.univs) {
            for(let v of this.state.univs[kana]) {
                options.push(<option key={v.id} value={v.id}>{v.name}</option>);
            }
        }
        return (
            <select className="form-control" name="school" value={this.state.clubtypes.id} onChange={(e)=>this.selectUniv(e)}>
                <option value="0">大学を選ぶ</option>
                {options}
            </select>
        );
    }
    getClubtypeById(id){
        for(let v of this.state.clubtypes) {
            if(v.id==id){
                return v;
            }
        }
        return {};
    }
    selectClubtype(e){
        this.setState({selected_clubtype: this.getClubtypeById(e.target.value)});
    }
    renderClubtypes(){
        if( Object.keys(this.state.clubtypes).length==0 ){
            return null;
        }
        let options = [];
        for(let v of this.state.clubtypes) {
            options.push(<option key={v.id} value={v.id}>{v.name}</option>);
        }
        return (
            <select className="form-control" name="school" value={this.state.clubtypes.id} onChange={(e)=>this.selectClubtype(e)}>
                <option value="0">競技を選ぶ</option>
                {options}
            </select>
        );
    }
    render() {
        return (
            <div>
                <div className="top-page">
                    <div className="process-toppage">
                        <div className="container">
                            <div className="float-right">
                                <div className="qa-header hidden-mb">
                                    <ul className="clearfix">
                                        <li>
                                            <img src="images/icon_qa.png"/>
                                        </li>
                                        <li>
                                            <Link to="/faq">
                                                <div>よくあるご質問</div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                            <div className="logo-header-top">
                                <img src="images/logo.png" className="img-fluid"/>
                            </div>
                            <div className="introduce-top-page">
                                サシイレは、あなたの応援する部活へ商品を差し入れできるサービスです
                            </div>
                            <div className="process-order-top">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6 col-6">
                                        <div className="item-step-order">
                                            <div className="img-step-order">
                                                <img src="images/01.png" className="img-fluid"/>
                                                <div className="arrow-left-steporder">
                                                    <img src="images/arrow.png" className="img-fluid"/>
                                                </div>
                                            </div>
                                            <div className="title-step-order">
                                                応援する部活を選択
                                            </div>
                                            <div className="description-step-order">
                                                母校や好きな競技、応援している部活動を選択してください。
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-6">
                                        <div className="item-step-order item-step-order-2">
                                            <div className="img-step-order">
                                                <img src="images/02.png" className="img-fluid"/>
                                                <div className="arrow-left-steporder hidden-mb">
                                                    <img src="images/arrow.png" className="img-fluid"/>
                                                </div>
                                            </div>
                                            <div className="title-step-order">
                                                差し入れ商品を購入
                                            </div>
                                            <div className="description-step-order">
                                                部活動が必要な商品の中から差し入れしたい商品を購入してください。
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-6">
                                        <div className="item-step-order">
                                            <div className="img-step-order">
                                                <img src="images/03.png" className="img-fluid"/>
                                                <div className="arrow-left-steporder">
                                                    <img src="images/arrow.png" className="img-fluid"/>
                                                </div>
                                            </div>
                                            <div className="title-step-order">
                                                部活に商品をお届け
                                            </div>
                                            <div className="description-step-order">
                                                商品が直接部活の練習場や寮に届き、選手の手に渡ります。
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-6">
                                        <div className="item-step-order item-step-order-4">
                                            <div className="img-step-order">
                                                <img src="images/04.png" className="img-fluid"/>
                                            </div>
                                            <div className="title-step-order">
                                                選手からのメッセージ
                                            </div>
                                            <div className="description-step-order">
                                                サシイレした部活からメールにお礼が届きます。
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="qa-header text-center display-mb">
                                    <ul className="clearfix">
                                        <li>
                                            <img src="images/icon_qa.png"/>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <div>よくあるご質問</div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="select-club-top">
                        <div className="container">
                            <div className="title-select-club-top">
                                部活選択
                            </div>
                            <div className="img-three-dot">
                                <img src="images/three-dot.png" className="img-fluid"/>
                            </div>
                            <div className="three-column-selectclub">
                                <div className="row">
                                    <div className="col-lg-4 full-width-column">
                                        <div className="column-selectclub-1 display-desktop">
                                            <div className="input-group" data-toggle="collapse" data-target="#option-school">
                                                <div className="input-group-prepend icon-left-form">
                                                    <img src="images/icon_01.png" className="img-fluid"/>
                                                </div>
                                                <div id="choose-school">
                                                    {this.state.selected_univ.name? this.state.selected_univ.name: '大学を選ぶ'}
                                                </div>
                                                <div className="input-group-prepend caret-option">
								  		<span className="input-group-text">
								    		<i className="fas fa-caret-down"></i>
								  		</span>
                                                </div>
                                            </div>
                                            <div className="img-column-selectclub hidden-mb-special">
                                                <img src="images/x.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                        <div className="column-selectclub-1 display-mb">
                                            <div className="input-group">
                                                <div className="input-group-prepend icon-left-form">
                                                    <img src="images/icon_01.png" className="img-fluid"/>
                                                </div>
                                                {this.renderUnivsSelect()}
                                            </div>
                                            <div className="img-column-selectclub hidden-mb-special">
                                                <img src="images/arrow.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                        <div className="img-column-selectclub display-mb">
                                            <img src="images/x.png" className="img-fluid"/>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 full-width-column">
                                        <div className="column-selectclub-2">
                                            <div className="input-group">
                                                <div className="input-group-prepend icon-left-form">
                                                    <img src="images/icon_02.png" className="img-fluid"/>
                                                </div>
                                                {this.renderClubtypes()}
                                            </div>
                                            <div className="img-column-selectclub hidden-mb-special">
                                                <img src="images/arrow.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                        <div className="img-column-selectclub display-mb">
                                            <img src="images/arrow_02.png" className="img-fluid"/>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 full-width-column">
                                        <a onClick={this.handleToClubPage}>
                                            <div className="btn-custom-toppage">
                                                サシイレする
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div id="option-school" className="collapse">
                                <div className="seven-column hidden-mb" id="school-position">
                                    <input type="hidden" name="school" id="school"/>
                                    <div className="icon-option">
                                        <i className="fas fa-caret-up"></i>
                                    </div>
                                    {this.renderUnivs()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Home